import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { useContext, useEffect, useState, Context as ReactContext } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { DataOwnerRecord } from '../../Pages/DataOwners/Models/DataOwnerRecord';

export function useGetDataOwner(dataownerId: string) {
  const [dataownerRecord, setDataOwnerRecord] = useState<DataOwnerRecord>(null);
  const [isDataOwnerRecordLoading, setIsDataOwnerRecordLoading] = useState<boolean>(true);
  const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

  useEffect(() => {
    setIsDataOwnerRecordLoading(true);
    httpClient
      .get<DataOwnerRecord>(`${__API_BASE_URL__}/tenant/getTenant?tenantId=${dataownerId}`, {
        resource: __CLIENT_ID__,
        headers: {
          'Content-Type': 'application/json',
          'X-Content-Type-Options': 'nosniff',
        },
      })
      .then(({ data }) => {
        setDataOwnerRecord(data);
        setIsDataOwnerRecordLoading(false);
      });
  }, [dataownerId]);

  return [dataownerRecord, isDataOwnerRecordLoading] as const;
}
